/* eslint-disable complexity */
import { RegionIdEnum } from '@search/filter-enums/enums/Region';
import { isSpbWide, isMskWide } from '@search/helpers/src/isRegion';

import { mskCity, mskOblCity } from './msk/mskCityMapper';
import { mskDistrict, mskOblDistrict } from './msk/mskDistrictMapper';
import { mskMetroStation, mskOblMetroStation } from './msk/mskMetroMapper';
import { mskOblRayon, mskRayon } from './msk/mskRayonMapper';
import { lenOblCity, spbCity } from './spb/spbCityMapper';
import { lenOblDistrict, spbDistrict } from './spb/spbDistrictMapper';
import { lenOblMetroStation, spbMetroStation } from './spb/spbMetroMapper';

export function detectRegion({
    geoSlug1: city,
    okrug,
    rayon,
    metro,
    region,
    isCanonical,
    isServer,
    geos
}: {
    geos: {
        kind?: string | null;
        id: number;
        title?: string | null;
        locative?: string | null;
        translit?: string | null;
        locality?: {
            id: number;
            locative: string;
        } | null;
        narrowRegion?: {
            id: number;
        };
    }[];
    region?: RegionIdEnum;
    metro?: string;
    geoSlug1?: string;
    okrug?: string;
    rayon?: string;
    isCanonical?: boolean;
    isServer?: boolean;
}): RegionIdEnum | undefined {
    const isMsk = isMskWide(region);

    const isSpb = isSpbWide(region);

    if (
        isMsk && (
            (city && mskCity[city as keyof typeof mskCity]) ||
            (metro && mskMetroStation[metro as keyof typeof mskMetroStation]) ||
            (rayon && mskRayon[rayon as keyof typeof mskRayon]) ||
            (okrug && mskDistrict[okrug as keyof typeof mskDistrict])
        )
    ) {
        if (isCanonical) return RegionIdEnum.MSK;
        if (region === RegionIdEnum.MSK_OBL) return isServer ? RegionIdEnum.MSK : RegionIdEnum.MSK_AND_MSK_OBL;
        return undefined;
    }

    if (
        isMsk && (
            (city && mskOblCity[city as keyof typeof mskOblCity]) ||
            (metro && mskOblMetroStation[metro as keyof typeof mskOblMetroStation]) ||
            (rayon && mskOblRayon[rayon as keyof typeof mskOblRayon]) ||
            (okrug && mskOblDistrict[okrug as keyof typeof mskOblDistrict])
        )
    ) {
        if (isCanonical) return RegionIdEnum.MSK_OBL;
        if (region === RegionIdEnum.MSK) return isServer ? RegionIdEnum.MSK_OBL : RegionIdEnum.MSK_AND_MSK_OBL;
        return undefined;
    }

    if (
        isSpb && (
            (city && spbCity[city as keyof typeof spbCity]) ||
            (metro && spbMetroStation[metro as keyof typeof spbMetroStation]) ||
            (rayon && spbDistrict[rayon as keyof typeof spbDistrict])
        )
    ) {
        if (isCanonical) return RegionIdEnum.SPB;
        if (region === RegionIdEnum.LEN_OBL) return isServer ? RegionIdEnum.SPB : RegionIdEnum.SPB_AND_LEN_OBL;
        return undefined;
    }

    if (
        isSpb && (
            (city && lenOblCity[city as keyof typeof lenOblCity]) ||
            (metro && lenOblMetroStation[metro as keyof typeof lenOblMetroStation]) ||
            (rayon && lenOblDistrict[rayon as keyof typeof lenOblDistrict])
        )
    ) {
        if (isCanonical) return RegionIdEnum.LEN_OBL;
        if (region === RegionIdEnum.SPB) return isServer ? RegionIdEnum.LEN_OBL : RegionIdEnum.SPB_AND_LEN_OBL;
        return undefined;
    }

    if (isCanonical) {
        if (region === RegionIdEnum.MSK_AND_MSK_OBL) {
            if (geos.some(geo => geo.narrowRegion?.id === RegionIdEnum.MSK_OBL && geo.translit === city)) {
                return RegionIdEnum.MSK_OBL;
            }
            return RegionIdEnum.MSK;
        }
        if (region === RegionIdEnum.SPB_AND_LEN_OBL) {
            if (geos.some(geo => geo.narrowRegion?.id === RegionIdEnum.LEN_OBL && geo.translit === city)) {
                return RegionIdEnum.LEN_OBL;
            }

            return RegionIdEnum.SPB;
        }
    }

    return undefined;
}
